// Cookies

import Cookies from 'js-cookie'

window.Cookies = Cookies;

// Axios Setup

import axios from "axios"

window.axios = axios;

// Fancybox

//import { ru } from './l10n/fancybox-ru.esm';
import {en}       from './l10n/fancybox-en.esm';
import {Fancybox} from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {

    // Локализация
    l10n: en,

    // Не скрывать полосу прокрутки, чтобы не было сдвига
    hideScrollbar: false,

    // Не использовать hash-навигацию, —
    // она используется для переключения репертуаров
    // в составном событии
    Hash: false,

    // Параметры миниатюр
    Thumbs: {
        // Не показывать миниатюры по умолчанию
        showOnStart: false,
    },
});

// Swiper

import Swiper from 'swiper'

import {A11y, Navigation, Pagination, Scrollbar, FreeMode, Autoplay, Thumbs, EffectFade} from 'swiper/modules'

Swiper.use([A11y, Navigation, Pagination, Scrollbar, FreeMode, Autoplay, Thumbs, EffectFade])

window.Swiper = Swiper

// QR Code

import QRCode from 'qrcode-svg';

window.QRCode = QRCode;

// Flip Counter

import Tick from '@pqina/flip';

window.Tick = Tick;

// Alpine Setup

import Alpine from 'alpinejs'

import anchor    from '@alpinejs/anchor'
import collapse  from '@alpinejs/collapse'
import focus     from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import resize    from '@alpinejs/resize'
import persist   from '@alpinejs/persist'

import {globalStore} from './store/global'
import {assistStore} from './store/assist'
import {mapStore}    from './store/map'

Alpine.plugin(anchor)
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(intersect)
Alpine.plugin(resize)
Alpine.plugin(persist)

Alpine.plugin(globalStore)
Alpine.plugin(assistStore(Alpine, Cookies))
Alpine.plugin(mapStore)

import xEventTicketButton from './components/event-ticket-button'
import xCheckboxToggle    from './components/checkbox-toggle'
import xCollapseContent   from './components/collapse-content'
import xLazyBackground    from './components/lazy-background'
import xMultiselect       from './components/multiselect'
import xPrimarySlider     from './components/primary-slider'
import xEventMediaLoader  from './components/event-media-loader'
import xFeaturedSlider    from './components/featured-slider'
import xGridSlider        from './components/grid-slider'
import xMediaSlider       from './components/media-slider'
import xMediaSliderPhoto  from './components/media-slider-photo'
import xMediaSliderVideo  from './components/media-slider-video'
import xPageFixedPanel    from './components/page-fixed-panel'
import xThreeColumnSlider from './components/three-column-slider'
import xSimpleImageSlider from './components/simple-image-slider'
import xPartnerLogoSlider from './components/partner-logo-slider'
import xSiteHeader        from './components/site-header'
import xSingleEventPage   from './components/single-event-page'
import xTagList           from './components/tag-list'
import xTheatreHistory    from './components/theatre-history'
import xPromoRotation     from './components/promo-rotation'
import xPhoneMask         from './components/phone-mask'
import xScrollToTop       from './components/scroll-to-top'

import xArchiveEvent       from './components/archive-event'
import xArchiveJournal     from './components/archive-journal'
import xArchivePremieres   from './components/archive-premieres'
import xArchiveProgress    from './components/archive-progress'
import xArchiveProject     from './components/archive-project'
import xArchiveRepertoire  from './components/archive-repertoire'
import xArchiveSearch      from './components/archive-search'
import xArchiveSuggestions from './components/archive-suggestions'
import xArchiveTag         from './components/archive-tag'
import xArchiveTouring     from './components/archive-touring'
import xArchiveVacancy     from './components/archive-vacancy'

import xArchiveEventCard from './components/archive-event-card'

import xContactForm              from './components/forms/contact'
import xSubscribeForm            from './components/forms/subscribe'
import xVacancyForm              from './components/forms/vacancy'
import xRentalForm               from './components/forms/rental'
import xPromoForm                from './components/forms/promo'
import xGiveawayRegistrationForm from './components/forms/giveaway-registration'

Alpine.data('xEventTicketButton', xEventTicketButton)
Alpine.data('xCheckboxToggle', xCheckboxToggle)
Alpine.data('xCollapseContent', xCollapseContent)
Alpine.data('xLazyBackground', xLazyBackground)
Alpine.data('xMultiselect', xMultiselect)
Alpine.data('xPrimarySlider', xPrimarySlider)
Alpine.data('xEventMediaLoader', xEventMediaLoader)
Alpine.data('xFeaturedSlider', xFeaturedSlider)
Alpine.data('xGridSlider', xGridSlider)
Alpine.data('xMediaSlider', xMediaSlider)
Alpine.data('xMediaSliderPhoto', xMediaSliderPhoto)
Alpine.data('xMediaSliderVideo', xMediaSliderVideo)
Alpine.data('xPageFixedPanel', xPageFixedPanel)
Alpine.data('xThreeColumnSlider', xThreeColumnSlider)
Alpine.data('xSimpleImageSlider', xSimpleImageSlider)
Alpine.data('xPartnerLogoSlider', xPartnerLogoSlider)
Alpine.data('xSiteHeader', xSiteHeader)
Alpine.data('xSingleEventPage', xSingleEventPage)
Alpine.data('xTagList', xTagList)
Alpine.data('xTheatreHistory', xTheatreHistory)
Alpine.data('xPromoRotation', xPromoRotation)
Alpine.data('xPhoneMask', xPhoneMask)
Alpine.data('xScrollToTop', xScrollToTop)

Alpine.data('xArchiveEvent', xArchiveEvent)
Alpine.data('xArchiveJournal', xArchiveJournal)
Alpine.data('xArchivePremieres', xArchivePremieres)
Alpine.data('xArchiveProgress', xArchiveProgress)
Alpine.data('xArchiveProject', xArchiveProject)
Alpine.data('xArchiveRepertoire', xArchiveRepertoire)
Alpine.data('xArchiveSearch', xArchiveSearch)
Alpine.data('xArchiveSuggestions', xArchiveSuggestions)
Alpine.data('xArchiveTag', xArchiveTag)
Alpine.data('xArchiveTouring', xArchiveTouring)
Alpine.data('xArchiveVacancy', xArchiveVacancy)

Alpine.data('xArchiveEventCard', xArchiveEventCard)

Alpine.data('xContactForm', xContactForm)
Alpine.data('xSubscribeForm', xSubscribeForm)
Alpine.data('xVacancyForm', xVacancyForm)
Alpine.data('xRentalForm', xRentalForm)
Alpine.data('xPromoForm', xPromoForm)
Alpine.data('xGiveawayRegistrationForm', xGiveawayRegistrationForm)

window.Alpine = Alpine

Alpine.start()

// Dark mode

import './dark-mode'

//

import './supports'

//

window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        console.log('Эта страница восстановлена из BFcache.');
    } else {
        console.log('Эта страница загрузилась по запросу.');

        const navEntries = performance.getEntriesByType("navigation");
        for (let i = 0; i < navEntries.length; i++) {
            console.log(`Navigation entry ${i}`);
            let navEntry = navEntries[i];
            console.log(navEntry.notRestoredReasons);
        }
    }
});

window.addEventListener('pagehide', function (event) {
    if (event.persisted === true) {
        console.log('*Возможно*, страница записана в BFcache.');
    } else {
        console.log('Эта страница будет выгружена нормально и будет удалена из памяти.');
    }
});

// Form success submit event test

document.addEventListener('form-send-success', (event) => {

    const formName = event.detail.formName;
    const data     = event.detail.data;
    const response = event.detail.response;
    const payload  = event.detail.payload;

    console.log('Form submitted:', formName);
    console.log('Received data:', data);
    console.log('Response:', response);
    console.log('Payload:', payload);
});

// Particle generator
import createParticlesAtElementCenter from './components/particle-generator'

window.createParticlesAtElementCenter = createParticlesAtElementCenter;
